const trackingData = [];
let sourceScriptReady = false;
let sourceScriptListener = false;
const loadSourceScript = () => {
    return new Promise((resolve, reject) => {
        try {
            const adobeSourceScript = document.getElementById('__adobe_launch_tracking');
            const onSourceLoaded = () => {
                resolve(true);
                return;
            };
            if (adobeSourceScript?.dataset.loaded === 'true') {
                onSourceLoaded();
            }
            if (!sourceScriptListener) {
                window.addEventListener('tagManagerLoaded', onSourceLoaded);
                sourceScriptListener = true;
            }
        }
        catch (error) {
            reject(error);
        }
    });
};
const loadAdobeTracking = async () => {
    try {
        await loadSourceScript();
        sourceScriptReady = true;
        sendTrackingData();
    }
    catch (error) {
        console.error(error);
    }
};
const sendTrackingData = () => {
    if (sourceScriptReady) {
        trackingData.forEach((event) => {
            window.adobeDataLayer.push(event);
        });
        trackingData.splice(0, trackingData.length);
    }
};
const trackInAdobe = (event) => {
    if (!sourceScriptReady) {
        loadAdobeTracking();
    }
    trackingData.push(event);
    sendTrackingData();
};

export { trackInAdobe };
//# sourceMappingURL=adobe.js.map
